import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FacilitiesInterlineDestinations from "../../../components/FacilitiesInterlineDestinations/FacilitiesInterlineDestinations";
import store from "../../../store";
import {Helmet} from "react-helmet";

const InterlineDestinations = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Facilities" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Interline Destinations" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <FacilitiesInterlineDestinations/>
    </div>
  )
};

export default InterlineDestinations;



// WEBPACK FOOTER //
// ./src/pages/ship/Facilities/InterlineDestinations.js